import '../../utils/index.mjs';
import InputNumber from './src/input-number2.mjs';
export { inputNumberEmits, inputNumberProps } from './src/input-number.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElInputNumber = withInstall(InputNumber);

export { ElInputNumber, ElInputNumber as default };
//# sourceMappingURL=index.mjs.map
